import PropTypes from 'prop-types'
import React, { useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import _ from 'lodash'
import Helmet from 'react-helmet'
import { artistsStateSelector as stateSelector } from 'reduxModules/artists/selectors'
import { artistsMergeProps as mergeProps } from 'reduxModules/artists/dispatchers'
import { artistsFetchMore } from 'reduxModules/artists'
import getLoadLimitByIndex from 'components/utils/getLoadLimitByIndex'
import LoadMore from '../../generic/LoadMore'
import Artist from '../../generic/ProfileSummary'

import './styles.css'

export function ArtistList(props) {
  const {
    loadArtists,
    pendingBackScroll,
    artists,
    nextArtists,
    setScrollingBackElement,
    router,
    route
  } = props

  const routerWillLeave = useCallback((nextLocation) => {
    if (_.startsWith(nextLocation.pathname, '/artists/')) {
      const slug = nextLocation.pathname.split('/')[2]
      const index = _.findIndex(artists, { slug })
      setScrollingBackElement({
        index,
        name: `artists-${index}`,
        group: 'artists'
      })
    }
    return true
  }, [artists, setScrollingBackElement])

  useEffect(() => {
    const limit = getLoadLimitByIndex(17, pendingBackScroll.artists)
    loadArtists({ limit })

    if (router?.setRouteLeaveHook) {
      router.setRouteLeaveHook(route, routerWillLeave)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <article id="ArtistList" className="wrapper">
      <Helmet>
        <title>Teachers | Stan Winston School of Character Arts</title>
        <meta
          name="description"
          content="Find the most talented professionals in the field of Special Effects Character Creation, Character Design & Makeup FX"
        />
        <meta
          property="og:title"
          content="Teachers | Stan Winston School of Character Arts"
        />
        <meta
          property="og:description"
          content="Find the most talented professionals in the field of Special Effects Character Creation, Character Design & Makeup FX"
        />
      </Helmet>

      <section className="heading">
        <h1>Teachers</h1>
      </section>

      <section className="artists-list-content">
        {artists.map((artist, idx) => (
          <Artist
            key={`artist-${idx}`}
            className="artist"
            elementName={`artists-${idx}`}
            name={artist.title}
            photo={artist.photo.boxThumb}
            slug={artist.slug}
          />
        ))}
      </section>

      {nextArtists && (
        <div className="load-more">
          <LoadMore
            fetchMoreAction={artistsFetchMore}
            next={nextArtists}
            listContainerId="ArtistList"
          />
        </div>
      )}
    </article>
  )
}

ArtistList.propTypes = {
  loadArtists: PropTypes.func.isRequired,
  artists: PropTypes.arrayOf(PropTypes.object),
  nextArtists: PropTypes.string,
  pendingBackScroll: PropTypes.shape({
    artists: PropTypes.shape({
      isPending: PropTypes.bool,
      element: PropTypes.shape({
        index: PropTypes.number,
        name: PropTypes.string
      })
    })
  }),
  setScrollingBackElement: PropTypes.func.isRequired,
  router: PropTypes.object,
  route: PropTypes.object
}

ArtistList.defaultProps = {
  artists: [],
  nextArtists: null,
  pendingBackScroll: {
    artists: {
      isPending: false,
      element: {
        index: 0,
        name: 'artists-0'
      }
    }
  },
  setScrollingBackElement: () => {},
  router: null,
  route: null
}

export default connect(
  stateSelector,
  null,
  mergeProps
)(withRouter(ArtistList))
